import { render } from "./ReceivedQueryForAlerts.vue?vue&type=template&id=13e2ed34"
import script from "./ReceivedQueryForAlerts.vue?vue&type=script&lang=js"
export * from "./ReceivedQueryForAlerts.vue?vue&type=script&lang=js"

import "./ReceivedQueryForAlerts.vue?vue&type=style&index=0&id=13e2ed34&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__